// Module
var code = "<hr> <p class=\"text-center\"> This site is realized with <a href=\"https://github.com/MorganCaron/custom-element-ts\">CustomElementTs</a> </p> ";
// Exports
export default code;